import type {
	AutoDispatchGlobalAccessorials,
	GlobalCarrier,
} from "~/shared/schemas/auto-dispatch-schema.ts";

import { AccessorialsFilterCell } from "../../components/grid/columns/accessorials-filter-cell/index.tsx";
import { HeaderCell } from "../../components/grid/columns/header-cell/index.tsx";
import { MultiSelectCell } from "../../components/grid/columns/multi-select-cell/index.tsx";
import type { column } from "./types.ts";
import type { CellWrapper } from "./with-loader.tsx";

export const accessorialsColumn = (
	cellWrapper: CellWrapper,
	globalAccessorials: AutoDispatchGlobalAccessorials,
	updateCarrier: ((carrier: GlobalCarrier) => void) | undefined,
): column => ({
	field: "accessorials",
	title: "Approved Accessorial Exceptions",
	group: ["global"],
	filterable: true,
	sortable: false,
	headerCell: (props) => (
		<HeaderCell
			title={props.title ?? ""}
			tooltipText={
				"Some accessorials cannot be auto dispatched with all carriers. Select the approved restricted accessorials each carrier supports for auto dispatch."
			}
		/>
	),
	filterCell: (props) => (
		<AccessorialsFilterCell {...props} accessorials={globalAccessorials} />
	),
	cells: {
		data: cellWrapper((props) => (
			<MultiSelectCell
				{...props}
				data={globalAccessorials}
				dataItemKey={"id"}
				onClose={(value: AutoDispatchGlobalAccessorials) => {
					updateCarrier?.({
						...(props.dataItem as GlobalCarrier),
						accessorials: value,
					});
				}}
				tagLimit={0}
				textField={"description"}
			/>
		)),
	},
});
